//import axios from 'axios';
// import fetchAxios from 'utils/ApiAxios';
// import { fetchData } from 'utils/ApiAxios';

//질병 카테고리 목록
export const diseases = [
  {title: 'Cancers'},
  {title: 'HIV/AIDS'},
  {title: 'Meningitis'},
  {title: 'Giardiasis'},
  {title: 'Tuberculosis'},
  {title: 'Diabetes'},
  {title: 'Salmonellosis'},
  {title: 'Gonorrhea'},
  {title: 'Trichomoniasis'}
]

//filter categories
export const categories = [
  {category: 'Children', isActive: false},
  {category: 'Pets', isActive: false},
  {category: 'Disasters', isActive: false},
  {category: 'Diseases', isActive: false, details: [...diseases]},
  {category: 'Others', isActive: false}
]

export const childrens = []

// const axios = require('axios');

// // Make a request for a user with a given ID
// var rresponse = [];
// fetchAxios.get('/getallweb')
//   .then(function (response) {
//     // handle success
//     console.log(response);
//     rresponse = [...response.data];
//   })
//   .catch(function (error) {
//     // handle error
//     console.log(error);
//   })
//   .finally(function () {
//     // always executed
//   });



// const response =  await fetchData();

// console.log(response)
// export const sampleCampaigns = [...response]



// category: 01-Childrens, 02-Pets, 03-Disasters, 04-Others
// 100 example campaigns
export const sampleCampaigns = [
  {
    category: 'Childrens',
    images: '',
    title: 'The Struggle for Pediatric Surgery: A Glimpse into the Lives of Those in Need',
    content:
      "Maria lived in a small, impoverished village where medical facilities were scarce and the closest hospital was miles away. Her young son, James, fell seriously ill and required urgent surgery. The cost of the surgery was beyond their means, and with a heavy heart, Maria reached out to her community for support. The villagers, though not well-off themselves, contributed what they could. Local churches and non-profits also stepped in, and with the help of generous donors from around the world, Maria was able to get James the life-saving surgery he needed. This story highlights the importance of community, empathy, and the impact that even a small donation can have on a child's life.",
    amount: '1200',
    createdAt: '2022-03-18',
    expiredAt: ' 2023-12-01'
    // idHash: 'abc1234'
  },
  {
    category: 'Childrens',
    images: '',
    title: 'A Second Chance at Life: The Heartwarming Story of Baby John ',
    content:
      "Baby John was born with a congenital heart defect, a condition that required immediate surgery. His family, living in a low-income neighborhood, had no means to afford the exorbitant medical costs. The clock was ticking, and Baby John's life was on the line. In an act of desperation, his family reached out to various non-profit organizations and set up a crowdfunding campaign. The response was overwhelming. Donations poured in from all corners of the globe, and Baby John was able to undergo the surgery. Today, he is a thriving toddler, full of life and energy. This story is a testament to the power of human kindness and the difference that we can make when we come together for a common cause.",
    amount: '10500',
    createdAt: '2021-10-11',
    expiredAt: ' 2024-01-15'
  },
  {
    category: 'Childrens',
    images: '',
    title: "Fighting for a Brighter Future: Emily's Brave Battle Against Cancer ",
    content:
      "At just eight years old, Emily was diagnosed with a rare form of cancer. The news was a devastating blow to her family, who were already struggling to make ends meet. The cost of the treatment was astronomical, but Emily's parents were determined to do whatever it took to save their daughter's life. They reached out to family, friends, and even strangers, sharing Emily's story and asking for financial support. The community rallied around them, and along with the help of charitable organizations and kind-hearted donors, Emily was able to receive the treatment she desperately needed. Today, she is cancer-free and has become a symbol of hope and resilience for many others facing similar challenges.",
    amount: '3800',
    createdAt: '2020-01-27',
    expiredAt: ' 2024-04-22'
  },
  {
    category: 'Childrens',
    images: '',
    title: "A Helping Hand: The Community's Role in Supporting Pediatric Care ",
    content:
      "Alex was a bright and energetic teenager who loved playing soccer. One day, while playing a match, he suffered a serious injury that required immediate surgery. His family, already burdened with financial difficulties, was crushed by the news. The medical bills were more than they could handle. But their community was not ready to let them fight this battle alone. Local businesses, neighbors, and even strangers came together to raise funds for Alex's surgery. They organized bake sales, car washes, and other fundraising events. The outpouring of support was incredible, and Alex was able to undergo the surgery. Today, he is back on the soccer field, living his dream, thanks to the generosity and kindness of those around him.",
    amount: '8200',
    createdAt: '2021-04-08',
    expiredAt: ' 2024-06-03'
  },
  {
    category: 'Childrens',
    images: '',
    title: "A Mother's Fight for Her Child: Emma's Incredible Journey to Recovery ",
    content:
      "Emma was just two years old when she was diagnosed with a rare and life-threatening illness. Her mother, a single parent working two jobs, was devastated by the news. The cost of the surgery and subsequent treatment was more than she could bear. In a desperate plea for help, she reached out to the public, sharing her daughter's story and asking for financial support. The response was heartwarming. People from all walks of life came forward to donate, and within weeks, the necessary funds were raised. Emma underwent the surgery and made a miraculous recovery. This story is a testament to the goodness that exists in the world and the incredible impact that one person's generosity can have on another's life.",
    amount: '15000',
    createdAt: '2022-11-25',
    expiredAt: ' 2023-12-31'
  },
  {
    category: 'Childrens',
    images: '',
    title: 'The Struggle for Pediatric Surgery: A Tale of Financial Hardship',
    content:
      "A detailed story about Emily, a seven-year-old girl who was diagnosed with a congenital heart defect. The family's insurance did not cover the full cost of the surgery, and they were faced with the overwhelming burden of medical bills. The local community came together to organize fundraisers, including a charity walk and a silent auction, to help Emily's family cover the costs. The article dives into the emotional toll this situation took on Emily's family and the community's incredible display of support.",
    amount: '6700',
    createdAt: '2020-08-15',
    expiredAt: ' 2024-07-12'
  },
  {
    category: 'Childrens',
    images: '',
    title: 'A Call for Help: Providing Life-Saving Surgery for Children in Need',
    content:
      'This comprehensive article provides an in-depth look at several charity organizations that specialize in funding surgeries for children whose families cannot afford the medical costs. It explores the process of how these charities work, the criteria for eligibility, and the stories of children who have benefited from these programs. The article also includes interviews with medical professionals and charity founders who share their experiences and the impact of these organizations.',
    amount: '4500',
    createdAt: '2022-05-07',
    expiredAt: ' 2024-05-28'
  },
  {
    category: 'Childrens',
    images: '',
    title: "The Hidden Costs of Childhood Illness: A Family's Journey",
    content:
      'A narrative that follows the Johnson family as they navigate the complex world of medical bills and insurance claims after their son, Michael, was hospitalized for pneumonia and needed surgery. The story sheds light on the often-overlooked costs associated with hospital stays, such as transportation, lost wages, and out-of-pocket expenses for medical equipment. The article also discusses the emotional and mental health impacts on the family and how they found support through a local non-profit organization.',
    amount: '9300',
    createdAt: '2020-02-13',
    expiredAt: ' 2024-07-03'
  },
  {
    category: 'Childrens',
    images: '',
    title: 'Breaking the Cycle: How Your Donations Can Help Children Access Medical Care',
    content:
      'This piece delves into the various ways in which donations can make a significant difference in the lives of children in need of medical care. It highlights the story of a young girl named Lily who was able to receive a life-changing surgery thanks to a scholarship fund set up by a local charity. The article also discusses the importance of transparency in charity organizations and how donors can ensure their contributions are being used effectively.',
    amount: '2100',
    createdAt: '2021-12-30',
    expiredAt: ' 2024-03-10'
  },
  {
    category: 'Childrens',
    images: '',
    title: 'Fighting for Their Lives: The Critical Need for Pediatric Surgical Funding',
    content:
      'An in-depth analysis of the current state of pediatric surgical funding, with a focus on the disparities in access to medical care for children in low-income families. The article features interviews with healthcare policy experts, surgeons, and families who have experienced these disparities firsthand. It also discusses potential solutions, such as government-funded programs and increased support for charity organizations.',
    amount: '7500',
    createdAt: '2022-09-16',
    expiredAt: ' 2024-02-25'
  },
  {
    category: 'Childrens',
    images: '',
    title: "From Desperation to Hope: A Young Boy's Surgery Success Story",
    content:
      "A heartfelt story about a young boy named Charlie who was born with a life-threatening condition that required immediate surgery. The article chronicles Charlie's journey from diagnosis to recovery, with a focus on the challenges his family faced in securing the necessary funds for the surgery. It also highlights the incredible support they received from their community and the medical team that performed the surgery.",
    amount: '14000',
    createdAt: '2021-06-04',
    expiredAt: ' 2024-04-02'
  },
  {
    category: 'Childrens',
    images: '',
    title: "The Impact of Community Support on Children's Health Outcomes",
    content:
      'A research-based article that explores the positive effects of community support on the health outcomes of children in need of surgery. The article includes data from several studies that have shown the benefits of social support in improving recovery times and overall well-being. It also features case studies of children who have benefited from community-funded surgeries and the long-term impacts on their lives.',
    amount: '11000',
    createdAt: '2020-10-08',
    expiredAt: ' 2024-01-30'
  },
  {
    category: 'Childrens',
    images: '',
    title: 'Bridging the Gap: The Role of Nonprofits in Pediatric Healthcare',
    content:
      'This article provides a comprehensive overview of how nonprofit organizations are filling the gap in pediatric healthcare services for children in poverty. It includes case studies of successful programs that have provided necessary surgeries for children in need and discusses the challenges these organizations face in securing funding and resources. The article also includes interviews with healthcare professionals and nonprofit leaders who share their insights on the importance of these programs.',
    amount: '5400',
    createdAt: '2020-06-18',
    expiredAt: ' 2023-12-07'
  },
  {
    category: 'Childrens',
    images: '',
    title: 'Saving Lives, One Donation at a Time: The Power of Giving to Pediatric Surgery Funds',
    content:
      'A motivational piece that encourages readers to donate to funds that support pediatric surgeries. The article includes stories of children who have benefited from these funds and the life-changing impact of the surgeries. It also discusses the different ways people can donate, from monetary contributions to volunteering time and resources. The article aims to inspire readers to take action and make a difference in the lives of children in need.',
    amount: '18000',
    createdAt: '2023-03-18',
    expiredAt: ' 2024-05-14'
  },
  {
    category: 'Childrens',
    images: '',
    title: 'In Their Time of Need: How You Can Help Children Facing Medical Crises',
    content:
      'A practical guide on how individuals can support children and families facing medical crises. The article provides information on the various ways people can help, from donating to surgery funds and volunteering at hospitals to providing emotional support for families. It also includes resources for those who want to learn more about pediatric medical crises and how they can get involved in advocacy efforts.',
    amount: '4800',
    createdAt: '2022-01-03',
    expiredAt: ' 2024-06-25'
  },
  {
    category: 'Childrens',
    images: '',
    title: 'The Struggle for Pediatric Surgery: A Glimpse into the Lives of Those in Need',
    content:
      "Maria lived in a small, impoverished village where medical facilities were scarce and the closest hospital was miles away. Her young son, James, fell seriously ill and required urgent surgery. The cost of the surgery was beyond their means, and with a heavy heart, Maria reached out to her community for support. The villagers, though not well-off themselves, contributed what they could. Local churches and non-profits also stepped in, and with the help of generous donors from around the world, Maria was able to get James the life-saving surgery he needed. This story highlights the importance of community, empathy, and the impact that even a small donation can have on a child's life.",
    amount: '12500',
    createdAt: '2022-07-14',
    expiredAt: ' 2024-02-10'
  },
  {
    category: 'Childrens',
    images: '',
    title: 'A Second Chance at Life: The Heartwarming Story of Baby John ',
    content:
      "Baby John was born with a congenital heart defect, a condition that required immediate surgery. His family, living in a low-income neighborhood, had no means to afford the exorbitant medical costs. The clock was ticking, and Baby John's life was on the line. In an act of desperation, his family reached out to various non-profit organizations and set up a crowdfunding campaign. The response was overwhelming. Donations poured in from all corners of the globe, and Baby John was able to undergo the surgery. Today, he is a thriving toddler, full of life and energy. This story is a testament to the power of human kindness and the difference that we can make when we come together for a common cause.",
    amount: '16000',
    createdAt: '2021-09-25',
    expiredAt: ' 2023-12-18'
  },
  {
    category: 'Childrens',
    images: '',
    title: "Fighting for a Brighter Future: Emily's Brave Battle Against Cancer ",
    content:
      "At just eight years old, Emily was diagnosed with a rare form of cancer. The news was a devastating blow to her family, who were already struggling to make ends meet. The cost of the treatment was astronomical, but Emily's parents were determined to do whatever it took to save their daughter's life. They reached out to family, friends, and even strangers, sharing Emily's story and asking for financial support. The community rallied around them, and along with the help of charitable organizations and kind-hearted donors, Emily was able to receive the treatment she desperately needed. Today, she is cancer-free and has become a symbol of hope and resilience for many others facing similar challenges.",
    amount: '8700',
    createdAt: '2020-11-27',
    expiredAt: ' 2024-06-15'
  },
  {
    category: 'Childrens',
    images: '',
    title: "A Helping Hand: The Community's Role in Supporting Pediatric Care ",
    content:
      "Alex was a bright and energetic teenager who loved playing soccer. One day, while playing a match, he suffered a serious injury that required immediate surgery. His family, already burdened with financial difficulties, was crushed by the news. The medical bills were more than they could handle. But their community was not ready to let them fight this battle alone. Local businesses, neighbors, and even strangers came together to raise funds for Alex's surgery. They organized bake sales, car washes, and other fundraising events. The outpouring of support was incredible, and Alex was able to undergo the surgery. Today, he is back on the soccer field, living his dream, thanks to the generosity and kindness of those around him.",
    amount: '10000',
    createdAt: '2023-01-01',
    expiredAt: ' 2024-01-07'
  },
  {
    category: 'Childrens',
    images: '',
    title: "A Mother's Fight for Her Child: Emma's Incredible Journey to Recovery ",
    content:
      "Emma was just two years old when she was diagnosed with a rare and life-threatening illness. Her mother, a single parent working two jobs, was devastated by the news. The cost of the surgery and subsequent treatment was more than she could bear. In a desperate plea for help, she reached out to the public, sharing her daughter's story and asking for financial support. The response was heartwarming. People from all walks of life came forward to donate, and within weeks, the necessary funds were raised. Emma underwent the surgery and made a miraculous recovery. This story is a testament to the goodness that exists in the world and the incredible impact that one person's generosity can have on another's life.",
    amount: '3000',
    createdAt: '2020-05-16',
    expiredAt: ' 2024-04-12'
  },
  {
    category: 'Childrens,Diseases',
    images: '',
    title: 'The Struggle for Pediatric Surgery: A Tale of Financial Hardship',
    content:
      "A detailed story about Emily, a seven-year-old girl who was diagnosed with a congenital heart defect. The family's insurance did not cover the full cost of the surgery, and they were faced with the overwhelming burden of medical bills. The local community came together to organize fundraisers, including a charity walk and a silent auction, to help Emily's family cover the costs. The article dives into the emotional toll this situation took on Emily's family and the community's incredible display of support.",
    amount: '17500',
    createdAt: '2021-03-10',
    expiredAt: ' 2023-12-27'
  },
  {
    category: 'Diseases',
    images: '',
    title: 'A Call for Help: Providing Life-Saving Surgery for Children in Need',
    content:
      'This comprehensive article provides an in-depth look at several charity organizations that specialize in funding surgeries for children whose families cannot afford the medical costs. It explores the process of how these charities work, the criteria for eligibility, and the stories of children who have benefited from these programs. The article also includes interviews with medical professionals and charity founders who share their experiences and the impact of these organizations.',
    amount: '13000',
    createdAt: '2022-08-05',
    expiredAt: ' 2024-07-20'
  },
  {
    category: 'Diseases',
    images: '',
    title: "The Hidden Costs of Childhood Illness: A Family's Journey",
    content:
      'A narrative that follows the Johnson family as they navigate the complex world of medical bills and insurance claims after their son, Michael, was hospitalized for pneumonia and needed surgery. The story sheds light on the often-overlooked costs associated with hospital stays, such as transportation, lost wages, and out-of-pocket expenses for medical equipment. The article also discusses the emotional and mental health impacts on the family and how they found support through a local non-profit organization.',
    amount: '2500',
    createdAt: '2020-03-02',
    expiredAt: ' 2024-07-29'
  },
  {
    category: 'Diseases',
    images: '',
    title: 'Breaking the Cycle: How Your Donations Can Help Children Access Medical Care',
    content:
      'This piece delves into the various ways in which donations can make a significant difference in the lives of children in need of medical care. It highlights the story of a young girl named Lily who was able to receive a life-changing surgery thanks to a scholarship fund set up by a local charity. The article also discusses the importance of transparency in charity organizations and how donors can ensure their contributions are being used effectively.',
    amount: '7200',
    createdAt: '2022-10-12',
    expiredAt: ' 2024-03-03'
  },
  {
    category: 'Diseases',
    images: '',
    title: 'Fighting for Their Lives: The Critical Need for Pediatric Surgical Funding',
    content:
      'An in-depth analysis of the current state of pediatric surgical funding, with a focus on the disparities in access to medical care for children in low-income families. The article features interviews with healthcare policy experts, surgeons, and families who have experienced these disparities firsthand. It also discusses potential solutions, such as government-funded programs and increased support for charity organizations.',
    amount: '6000',
    createdAt: '2023-10-22',
    expiredAt: ' 2024-01-21'
  },
  {
    category: 'Diseases',
    images: '',
    title: "From Desperation to Hope: A Young Boy's Surgery Success Story",
    content:
      "A heartfelt story about a young boy named Charlie who was born with a life-threatening condition that required immediate surgery. The article chronicles Charlie's journey from diagnosis to recovery, with a focus on the challenges his family faced in securing the necessary funds for the surgery. It also highlights the incredible support they received from their community and the medical team that performed the surgery.",
    amount: '20000',
    createdAt: '2021-08-09',
    expiredAt: ' 2024-06-08'
  },
  {
    category: 'Diseases',
    images: '',
    title: "The Impact of Community Support on Children's Health Outcomes",
    content:
      'A research-based article that explores the positive effects of community support on the health outcomes of children in need of surgery. The article includes data from several studies that have shown the benefits of social support in improving recovery times and overall well-being. It also features case studies of children who have benefited from community-funded surgeries and the long-term impacts on their lives.',
    amount: '5000',
    createdAt: '2021-11-17',
    expiredAt: ' 2024-03-17'
  },
  {
    category: 'Diseases',
    images: '',
    title: 'Bridging the Gap: The Role of Nonprofits in Pediatric Healthcare',
    content:
      'This article provides a comprehensive overview of how nonprofit organizations are filling the gap in pediatric healthcare services for children in poverty. It includes case studies of successful programs that have provided necessary surgeries for children in need and discusses the challenges these organizations face in securing funding and resources. The article also includes interviews with healthcare professionals and nonprofit leaders who share their insights on the importance of these programs.',
    amount: '19000',
    createdAt: '2022-06-26',
    expiredAt: ' 2024-04-05'
  },
  {
    category: 'Diseases',
    images: '',
    title: 'Saving Lives, One Donation at a Time: The Power of Giving to Pediatric Surgery Funds',
    content:
      'A motivational piece that encourages readers to donate to funds that support pediatric surgeries. The article includes stories of children who have benefited from these funds and the life-changing impact of the surgeries. It also discusses the different ways people can donate, from monetary contributions to volunteering time and resources. The article aims to inspire readers to take action and make a difference in the lives of children in need.',
    amount: '1000',
    createdAt: '2020-09-24',
    expiredAt: ' 2024-05-03'
  },
  {
    category: 'Diseases',
    images: '',
    title: 'In Their Time of Need: How You Can Help Children Facing Medical Crises',
    content:
      'A practical guide on how individuals can support children and families facing medical crises. The article provides information on the various ways people can help, from donating to surgery funds and volunteering at hospitals to providing emotional support for families. It also includes resources for those who want to learn more about pediatric medical crises and how they can get involved in advocacy efforts.',
    amount: '9000',
    createdAt: '2021-01-14',
    expiredAt: ' 2024-07-26'
  },
  {
    category: 'Diseases',
    images: '',
    title: 'The Struggle for Pediatric Surgery: A Glimpse into the Lives of Those in Need',
    content:
      "Maria lived in a small, impoverished village where medical facilities were scarce and the closest hospital was miles away. Her young son, James, fell seriously ill and required urgent surgery. The cost of the surgery was beyond their means, and with a heavy heart, Maria reached out to her community for support. The villagers, though not well-off themselves, contributed what they could. Local churches and non-profits also stepped in, and with the help of generous donors from around the world, Maria was able to get James the life-saving surgery he needed. This story highlights the importance of community, empathy, and the impact that even a small donation can have on a child's life.",
    amount: '11500',
    createdAt: '2022-04-03',
    expiredAt: ' 2024-05-20'
  },
  {
    category: 'Diseases',
    images: '',
    title: 'A Second Chance at Life: The Heartwarming Story of Baby John ',
    content:
      "Baby John was born with a congenital heart defect, a condition that required immediate surgery. His family, living in a low-income neighborhood, had no means to afford the exorbitant medical costs. The clock was ticking, and Baby John's life was on the line. In an act of desperation, his family reached out to various non-profit organizations and set up a crowdfunding campaign. The response was overwhelming. Donations poured in from all corners of the globe, and Baby John was able to undergo the surgery. Today, he is a thriving toddler, full of life and energy. This story is a testament to the power of human kindness and the difference that we can make when we come together for a common cause.",
    amount: '21000',
    createdAt: '2020-12-20',
    expiredAt: ' 2024-06-21'
  },
  {
    category: 'Diseases',
    images: '',
    title: "Fighting for a Brighter Future: Emily's Brave Battle Against Cancer ",
    content:
      "At just eight years old, Emily was diagnosed with a rare form of cancer. The news was a devastating blow to her family, who were already struggling to make ends meet. The cost of the treatment was astronomical, but Emily's parents were determined to do whatever it took to save their daughter's life. They reached out to family, friends, and even strangers, sharing Emily's story and asking for financial support. The community rallied around them, and along with the help of charitable organizations and kind-hearted donors, Emily was able to receive the treatment she desperately needed. Today, she is cancer-free and has become a symbol of hope and resilience for many others facing similar challenges.",
    amount: '12000',
    createdAt: '2021-05-02',
    expiredAt: ' 2024-02-18'
  },
  {
    category: 'Diseases',
    images: '',
    title: "A Helping Hand: The Community's Role in Supporting Pediatric Care ",
    content:
      "Alex was a bright and energetic teenager who loved playing soccer. One day, while playing a match, he suffered a serious injury that required immediate surgery. His family, already burdened with financial difficulties, was crushed by the news. The medical bills were more than they could handle. But their community was not ready to let them fight this battle alone. Local businesses, neighbors, and even strangers came together to raise funds for Alex's surgery. They organized bake sales, car washes, and other fundraising events. The outpouring of support was incredible, and Alex was able to undergo the surgery. Today, he is back on the soccer field, living his dream, thanks to the generosity and kindness of those around him.",
    amount: '4000',
    createdAt: '2021-07-21',
    expiredAt: ' 2024-04-28'
  },
  {
    category: 'Diseases',
    images: '',
    title: "A Mother's Fight for Her Child: Emma's Incredible Journey to Recovery ",
    content:
      "Emma was just two years old when she was diagnosed with a rare and life-threatening illness. Her mother, a single parent working two jobs, was devastated by the news. The cost of the surgery and subsequent treatment was more than she could bear. In a desperate plea for help, she reached out to the public, sharing her daughter's story and asking for financial support. The response was heartwarming. People from all walks of life came forward to donate, and within weeks, the necessary funds were raised. Emma underwent the surgery and made a miraculous recovery. This story is a testament to the goodness that exists in the world and the incredible impact that one person's generosity can have on another's life.",
    amount: '2000',
    createdAt: '2020-07-03',
    expiredAt: ' 2024-01-02'
  },
  {
    category: 'Diseases',
    images: '',
    title: 'The Struggle for Pediatric Surgery: A Tale of Financial Hardship',
    content:
      "A detailed story about Emily, a seven-year-old girl who was diagnosed with a congenital heart defect. The family's insurance did not cover the full cost of the surgery, and they were faced with the overwhelming burden of medical bills. The local community came together to organize fundraisers, including a charity walk and a silent auction, to help Emily's family cover the costs. The article dives into the emotional toll this situation took on Emily's family and the community's incredible display of support.",
    amount: '3500',
    createdAt: '2023-02-17',
    expiredAt: ' 2024-02-03'
  },
  {
    category: 'Diseases',
    images: '',
    title: 'A Call for Help: Providing Life-Saving Surgery for Children in Need',
    content:
      'This comprehensive article provides an in-depth look at several charity organizations that specialize in funding surgeries for children whose families cannot afford the medical costs. It explores the process of how these charities work, the criteria for eligibility, and the stories of children who have benefited from these programs. The article also includes interviews with medical professionals and charity founders who share their experiences and the impact of these organizations.',
    amount: '13500',
    createdAt: '2023-07-12',
    expiredAt: ' 2024-03-24'
  },
  {
    category: 'Diseases',
    images: '',
    title: "The Hidden Costs of Childhood Illness: A Family's Journey",
    content:
      'A narrative that follows the Johnson family as they navigate the complex world of medical bills and insurance claims after their son, Michael, was hospitalized for pneumonia and needed surgery. The story sheds light on the often-overlooked costs associated with hospital stays, such as transportation, lost wages, and out-of-pocket expenses for medical equipment. The article also discusses the emotional and mental health impacts on the family and how they found support through a local non-profit organization.',
    amount: '14500',
    createdAt: '2023-09-04',
    expiredAt: ' 2024-03-31'
  },
  {
    category: 'Diseases',
    images: '',
    title: 'Breaking the Cycle: How Your Donations Can Help Children Access Medical Care',
    content:
      'This piece delves into the various ways in which donations can make a significant difference in the lives of children in need of medical care. It highlights the story of a young girl named Lily who was able to receive a life-changing surgery thanks to a scholarship fund set up by a local charity. The article also discusses the importance of transparency in charity organizations and how donors can ensure their contributions are being used effectively.',
    amount: '7800',
    createdAt: '2022-02-20',
    expiredAt: ' 2024-06-01'
  },
  {
    category: 'Pets',
    images: '',
    title: 'Fighting for Their Lives: The Critical Need for Pediatric Surgical Funding',
    content:
      'An in-depth analysis of the current state of pediatric surgical funding, with a focus on the disparities in access to medical care for children in low-income families. The article features interviews with healthcare policy experts, surgeons, and families who have experienced these disparities firsthand. It also discusses potential solutions, such as government-funded programs and increased support for charity organizations.',
    amount: '18500',
    createdAt: '2020-04-15',
    expiredAt: ' 2024-02-12'
  },
  {
    category: 'Pets',
    images: '',
    title: "From Desperation to Hope: A Young Boy's Surgery Success Story",
    content:
      "A heartfelt story about a young boy named Charlie who was born with a life-threatening condition that required immediate surgery. The article chronicles Charlie's journey from diagnosis to recovery, with a focus on the challenges his family faced in securing the necessary funds for the surgery. It also highlights the incredible support they received from their community and the medical team that performed the surgery.",
    amount: '22000',
    createdAt: '2022-12-09',
    expiredAt: ' 2024-07-10'
  },
  {
    category: 'Pets',
    images: '',
    title: "The Impact of Community Support on Children's Health Outcomes",
    content:
      'A research-based article that explores the positive effects of community support on the health outcomes of children in need of surgery. The article includes data from several studies that have shown the benefits of social support in improving recovery times and overall well-being. It also features case studies of children who have benefited from community-funded surgeries and the long-term impacts on their lives.',
    amount: '8000',
    createdAt: '2021-02-04',
    expiredAt: ' 2024-04-18'
  },
  {
    category: 'Pets',
    images: '',
    title: 'Bridging the Gap: The Role of Nonprofits in Pediatric Healthcare',
    content:
      'This article provides a comprehensive overview of how nonprofit organizations are filling the gap in pediatric healthcare services for children in poverty. It includes case studies of successful programs that have provided necessary surgeries for children in need and discusses the challenges these organizations face in securing funding and resources. The article also includes interviews with healthcare professionals and nonprofit leaders who share their insights on the importance of these programs.',
    amount: '16500',
    createdAt: '2020-10-29',
    expiredAt: ' 2024-05-09'
  },
  {
    category: 'Pets',
    images: '',
    title: 'Saving Lives, One Donation at a Time: The Power of Giving to Pediatric Surgery Funds',
    content:
      'A motivational piece that encourages readers to donate to funds that support pediatric surgeries. The article includes stories of children who have benefited from these funds and the life-changing impact of the surgeries. It also discusses the different ways people can donate, from monetary contributions to volunteering time and resources. The article aims to inspire readers to take action and make a difference in the lives of children in need.',
    amount: '15500',
    createdAt: '2022-04-29',
    expiredAt: ' 2024-01-12'
  },
  {
    category: 'Pets',
    images: '',
    title: 'In Their Time of Need: How You Can Help Children Facing Medical Crises',
    content:
      'A practical guide on how individuals can support children and families facing medical crises. The article provides information on the various ways people can help, from donating to surgery funds and volunteering at hospitals to providing emotional support for families. It also includes resources for those who want to learn more about pediatric medical crises and how they can get involved in advocacy efforts.',
    amount: '6500',
    createdAt: '2023-05-15',
    expiredAt: ' 2024-03-07'
  },
  {
    category: 'Pets',
    images: '',
    title: 'The Struggle for Pediatric Surgery: A Glimpse into the Lives of Those in Need',
    content:
      "Maria lived in a small, impoverished village where medical facilities were scarce and the closest hospital was miles away. Her young son, James, fell seriously ill and required urgent surgery. The cost of the surgery was beyond their means, and with a heavy heart, Maria reached out to her community for support. The villagers, though not well-off themselves, contributed what they could. Local churches and non-profits also stepped in, and with the help of generous donors from around the world, Maria was able to get James the life-saving surgery he needed. This story highlights the importance of community, empathy, and the impact that even a small donation can have on a child's life.",
    amount: '3300',
    createdAt: '2021-07-03',
    expiredAt: ' 2024-04-25'
  },
  {
    category: 'Pets',
    images: '',
    title: 'A Second Chance at Life: The Heartwarming Story of Baby John ',
    content:
      "Baby John was born with a congenital heart defect, a condition that required immediate surgery. His family, living in a low-income neighborhood, had no means to afford the exorbitant medical costs. The clock was ticking, and Baby John's life was on the line. In an act of desperation, his family reached out to various non-profit organizations and set up a crowdfunding campaign. The response was overwhelming. Donations poured in from all corners of the globe, and Baby John was able to undergo the surgery. Today, he is a thriving toddler, full of life and energy. This story is a testament to the power of human kindness and the difference that we can make when we come together for a common cause.",
    amount: '1800',
    createdAt: '2023-08-19',
    expiredAt: ' 2024-02-05'
  },
  {
    category: 'Pets',
    images: '',
    title: "Fighting for a Brighter Future: Emily's Brave Battle Against Cancer ",
    content:
      "At just eight years old, Emily was diagnosed with a rare form of cancer. The news was a devastating blow to her family, who were already struggling to make ends meet. The cost of the treatment was astronomical, but Emily's parents were determined to do whatever it took to save their daughter's life. They reached out to family, friends, and even strangers, sharing Emily's story and asking for financial support. The community rallied around them, and along with the help of charitable organizations and kind-hearted donors, Emily was able to receive the treatment she desperately needed. Today, she is cancer-free and has become a symbol of hope and resilience for many others facing similar challenges.",
    amount: '24000',
    createdAt: '2022-06-12',
    expiredAt: ' 2023-12-08'
  },
  {
    category: 'Pets',
    images: '',
    title: "A Helping Hand: The Community's Role in Supporting Pediatric Care ",
    content:
      "Alex was a bright and energetic teenager who loved playing soccer. One day, while playing a match, he suffered a serious injury that required immediate surgery. His family, already burdened with financial difficulties, was crushed by the news. The medical bills were more than they could handle. But their community was not ready to let them fight this battle alone. Local businesses, neighbors, and even strangers came together to raise funds for Alex's surgery. They organized bake sales, car washes, and other fundraising events. The outpouring of support was incredible, and Alex was able to undergo the surgery. Today, he is back on the soccer field, living his dream, thanks to the generosity and kindness of those around him.",
    amount: '23000',
    createdAt: '2020-07-20',
    expiredAt: ' 2024-05-12'
  },
  {
    category: 'Disasters',
    images: '',
    title: "A Mother's Fight for Her Child: Emma's Incredible Journey to Recovery ",
    content:
      "Emma was just two years old when she was diagnosed with a rare and life-threatening illness. Her mother, a single parent working two jobs, was devastated by the news. The cost of the surgery and subsequent treatment was more than she could bear. In a desperate plea for help, she reached out to the public, sharing her daughter's story and asking for financial support. The response was heartwarming. People from all walks of life came forward to donate, and within weeks, the necessary funds were raised. Emma underwent the surgery and made a miraculous recovery. This story is a testament to the goodness that exists in the world and the incredible impact that one person's generosity can have on another's life.",
    amount: '2800',
    createdAt: '2021-12-06',
    expiredAt: ' 2024-06-18'
  },
  {
    category: 'Disasters',
    images: '',
    title: 'The Struggle for Pediatric Surgery: A Tale of Financial Hardship',
    content:
      "A detailed story about Emily, a seven-year-old girl who was diagnosed with a congenital heart defect. The family's insurance did not cover the full cost of the surgery, and they were faced with the overwhelming burden of medical bills. The local community came together to organize fundraisers, including a charity walk and a silent auction, to help Emily's family cover the costs. The article dives into the emotional toll this situation took on Emily's family and the community's incredible display of support.",
    amount: '1500',
    createdAt: '2023-06-14',
    expiredAt: ' 2024-07-07'
  },
  {
    category: 'Disasters',
    images: '',
    title: 'A Call for Help: Providing Life-Saving Surgery for Children in Need',
    content:
      'This comprehensive article provides an in-depth look at several charity organizations that specialize in funding surgeries for children whose families cannot afford the medical costs. It explores the process of how these charities work, the criteria for eligibility, and the stories of children who have benefited from these programs. The article also includes interviews with medical professionals and charity founders who share their experiences and the impact of these organizations.',
    amount: '17000',
    createdAt: '2020-03-27',
    expiredAt: ' 2023-12-10'
  },
  {
    category: 'Disasters',
    images: '',
    title: "The Hidden Costs of Childhood Illness: A Family's Journey",
    content:
      'A narrative that follows the Johnson family as they navigate the complex world of medical bills and insurance claims after their son, Michael, was hospitalized for pneumonia and needed surgery. The story sheds light on the often-overlooked costs associated with hospital stays, such as transportation, lost wages, and out-of-pocket expenses for medical equipment. The article also discusses the emotional and mental health impacts on the family and how they found support through a local non-profit organization.',
    amount: '13800',
    createdAt: '2021-11-05',
    expiredAt: ' 2024-06-27'
  },
  {
    category: 'Disasters',
    images: '',
    title: 'Breaking the Cycle: How Your Donations Can Help Children Access Medical Care',
    content:
      'This piece delves into the various ways in which donations can make a significant difference in the lives of children in need of medical care. It highlights the story of a young girl named Lily who was able to receive a life-changing surgery thanks to a scholarship fund set up by a local charity. The article also discusses the importance of transparency in charity organizations and how donors can ensure their contributions are being used effectively.',
    amount: '9800',
    createdAt: '2020-09-03',
    expiredAt: ' 2024-01-26'
  },
  {
    category: 'Disasters',
    images: '',
    title: 'Fighting for Their Lives: The Critical Need for Pediatric Surgical Funding',
    content:
      'An in-depth analysis of the current state of pediatric surgical funding, with a focus on the disparities in access to medical care for children in low-income families. The article features interviews with healthcare policy experts, surgeons, and families who have experienced these disparities firsthand. It also discusses potential solutions, such as government-funded programs and increased support for charity organizations.',
    amount: '5800',
    createdAt: '2023-04-15',
    expiredAt: ' 2024-03-21'
  },
  {
    category: 'Disasters',
    images: '',
    title: "From Desperation to Hope: A Young Boy's Surgery Success Story",
    content:
      "A heartfelt story about a young boy named Charlie who was born with a life-threatening condition that required immediate surgery. The article chronicles Charlie's journey from diagnosis to recovery, with a focus on the challenges his family faced in securing the necessary funds for the surgery. It also highlights the incredible support they received from their community and the medical team that performed the surgery.",
    amount: '14800',
    createdAt: '2020-05-02',
    expiredAt: ' 2024-05-07'
  },
  {
    category: 'Disasters',
    images: '',
    title: "The Impact of Community Support on Children's Health Outcomes",
    content:
      'A research-based article that explores the positive effects of community support on the health outcomes of children in need of surgery. The article includes data from several studies that have shown the benefits of social support in improving recovery times and overall well-being. It also features case studies of children who have benefited from community-funded surgeries and the long-term impacts on their lives.',
    amount: '11800',
    createdAt: '2021-01-25',
    expiredAt: ' 2024-02-20'
  },
  {
    category: 'Disasters',
    images: '',
    title: 'Bridging the Gap: The Role of Nonprofits in Pediatric Healthcare',
    content:
      'This article provides a comprehensive overview of how nonprofit organizations are filling the gap in pediatric healthcare services for children in poverty. It includes case studies of successful programs that have provided necessary surgeries for children in need and discusses the challenges these organizations face in securing funding and resources. The article also includes interviews with healthcare professionals and nonprofit leaders who share their insights on the importance of these programs.',
    amount: '25000',
    createdAt: '2022-12-29',
    expiredAt: ' 2024-04-15'
  },
  {
    category: 'Disasters',
    images: '',
    title: 'Saving Lives, One Donation at a Time: The Power of Giving to Pediatric Surgery Funds',
    content:
      'A motivational piece that encourages readers to donate to funds that support pediatric surgeries. The article includes stories of children who have benefited from these funds and the life-changing impact of the surgeries. It also discusses the different ways people can donate, from monetary contributions to volunteering time and resources. The article aims to inspire readers to take action and make a difference in the lives of children in need.',
    amount: '21500',
    createdAt: '2020-12-05',
    expiredAt: ' 2024-01-19'
  },
  {
    category: 'Disasters',
    images: '',
    title: 'In Their Time of Need: How You Can Help Children Facing Medical Crises',
    content:
      'A practical guide on how individuals can support children and families facing medical crises. The article provides information on the various ways people can help, from donating to surgery funds and volunteering at hospitals to providing emotional support for families. It also includes resources for those who want to learn more about pediatric medical crises and how they can get involved in advocacy efforts.',
    amount: '8500',
    createdAt: '2021-05-19',
    expiredAt: ' 2024-05-30'
  },
  {
    category: 'Disasters',
    images: '',
    title: 'The Struggle for Pediatric Surgery: A Glimpse into the Lives of Those in Need',
    content:
      "Maria lived in a small, impoverished village where medical facilities were scarce and the closest hospital was miles away. Her young son, James, fell seriously ill and required urgent surgery. The cost of the surgery was beyond their means, and with a heavy heart, Maria reached out to her community for support. The villagers, though not well-off themselves, contributed what they could. Local churches and non-profits also stepped in, and with the help of generous donors from around the world, Maria was able to get James the life-saving surgery he needed. This story highlights the importance of community, empathy, and the impact that even a small donation can have on a child's life.",
    amount: '15800',
    createdAt: '2023-03-02',
    expiredAt: ' 2024-07-05'
  },
  {
    category: 'Disasters',
    images: '',
    title: 'A Second Chance at Life: The Heartwarming Story of Baby John ',
    content:
      "Baby John was born with a congenital heart defect, a condition that required immediate surgery. His family, living in a low-income neighborhood, had no means to afford the exorbitant medical costs. The clock was ticking, and Baby John's life was on the line. In an act of desperation, his family reached out to various non-profit organizations and set up a crowdfunding campaign. The response was overwhelming. Donations poured in from all corners of the globe, and Baby John was able to undergo the surgery. Today, he is a thriving toddler, full of life and energy. This story is a testament to the power of human kindness and the difference that we can make when we come together for a common cause.",
    amount: '10800',
    createdAt: '2021-08-25',
    expiredAt: ' 2024-07-17'
  },
  {
    category: 'Disasters',
    images: '',
    title: "Fighting for a Brighter Future: Emily's Brave Battle Against Cancer ",
    content:
      "At just eight years old, Emily was diagnosed with a rare form of cancer. The news was a devastating blow to her family, who were already struggling to make ends meet. The cost of the treatment was astronomical, but Emily's parents were determined to do whatever it took to save their daughter's life. They reached out to family, friends, and even strangers, sharing Emily's story and asking for financial support. The community rallied around them, and along with the help of charitable organizations and kind-hearted donors, Emily was able to receive the treatment she desperately needed. Today, she is cancer-free and has become a symbol of hope and resilience for many others facing similar challenges.",
    amount: '6300',
    createdAt: '2020-02-28',
    expiredAt: ' 2024-02-15'
  },
  {
    category: 'Disasters',
    images: '',
    title: "A Helping Hand: The Community's Role in Supporting Pediatric Care ",
    content:
      "Alex was a bright and energetic teenager who loved playing soccer. One day, while playing a match, he suffered a serious injury that required immediate surgery. His family, already burdened with financial difficulties, was crushed by the news. The medical bills were more than they could handle. But their community was not ready to let them fight this battle alone. Local businesses, neighbors, and even strangers came together to raise funds for Alex's surgery. They organized bake sales, car washes, and other fundraising events. The outpouring of support was incredible, and Alex was able to undergo the surgery. Today, he is back on the soccer field, living his dream, thanks to the generosity and kindness of those around him.",
    amount: '3700',
    createdAt: '2020-04-01',
    expiredAt: ' 2024-06-13'
  },
  {
    category: 'Disasters',
    images: '',
    title: "A Mother's Fight for Her Child: Emma's Incredible Journey to Recovery ",
    content:
      "Emma was just two years old when she was diagnosed with a rare and life-threatening illness. Her mother, a single parent working two jobs, was devastated by the news. The cost of the surgery and subsequent treatment was more than she could bear. In a desperate plea for help, she reached out to the public, sharing her daughter's story and asking for financial support. The response was heartwarming. People from all walks of life came forward to donate, and within weeks, the necessary funds were raised. Emma underwent the surgery and made a miraculous recovery. This story is a testament to the goodness that exists in the world and the incredible impact that one person's generosity can have on another's life.",
    amount: '5700',
    createdAt: '2022-07-06',
    expiredAt: ' 2023-12-15'
  },
  {
    category: 'Disasters',
    images: '',
    title: 'The Struggle for Pediatric Surgery: A Tale of Financial Hardship',
    content:
      "A detailed story about Emily, a seven-year-old girl who was diagnosed with a congenital heart defect. The family's insurance did not cover the full cost of the surgery, and they were faced with the overwhelming burden of medical bills. The local community came together to organize fundraisers, including a charity walk and a silent auction, to help Emily's family cover the costs. The article dives into the emotional toll this situation took on Emily's family and the community's incredible display of support.",
    amount: '2600',
    createdAt: '2021-09-11',
    expiredAt: ' 2024-03-01'
  },
  {
    category: 'Disasters',
    images: '',
    title: 'A Call for Help: Providing Life-Saving Surgery for Children in Need',
    content:
      'This comprehensive article provides an in-depth look at several charity organizations that specialize in funding surgeries for children whose families cannot afford the medical costs. It explores the process of how these charities work, the criteria for eligibility, and the stories of children who have benefited from these programs. The article also includes interviews with medical professionals and charity founders who share their experiences and the impact of these organizations.',
    amount: '1300',
    createdAt: '2022-10-03',
    expiredAt: ' 2024-06-10'
  },
  {
    category: 'Disasters',
    images: '',
    title: "The Hidden Costs of Childhood Illness: A Family's Journey",
    content:
      'A narrative that follows the Johnson family as they navigate the complex world of medical bills and insurance claims after their son, Michael, was hospitalized for pneumonia and needed surgery. The story sheds light on the often-overlooked costs associated with hospital stays, such as transportation, lost wages, and out-of-pocket expenses for medical equipment. The article also discusses the emotional and mental health impacts on the family and how they found support through a local non-profit organization.',
    amount: '9500',
    createdAt: '2020-06-29',
    expiredAt: ' 2024-07-15'
  },
  {
    category: 'Others',
    images: '',
    title: 'Breaking the Cycle: How Your Donations Can Help Children Access Medical Care',
    content:
      'This piece delves into the various ways in which donations can make a significant difference in the lives of children in need of medical care. It highlights the story of a young girl named Lily who was able to receive a life-changing surgery thanks to a scholarship fund set up by a local charity. The article also discusses the importance of transparency in charity organizations and how donors can ensure their contributions are being used effectively.',
    amount: '4700',
    createdAt: '2021-04-21',
    expiredAt: ' 2023-12-23'
  },
  {
    category: 'Others',
    images: '',
    title: 'Fighting for Their Lives: The Critical Need for Pediatric Surgical Funding',
    content:
      'An in-depth analysis of the current state of pediatric surgical funding, with a focus on the disparities in access to medical care for children in low-income families. The article features interviews with healthcare policy experts, surgeons, and families who have experienced these disparities firsthand. It also discusses potential solutions, such as government-funded programs and increased support for charity organizations.',
    amount: '7000',
    createdAt: '2023-01-14',
    expiredAt: ' 2024-05-25'
  },
  {
    category: 'Others',
    images: '',
    title: "From Desperation to Hope: A Young Boy's Surgery Success Story",
    content:
      "A heartfelt story about a young boy named Charlie who was born with a life-threatening condition that required immediate surgery. The article chronicles Charlie's journey from diagnosis to recovery, with a focus on the challenges his family faced in securing the necessary funds for the surgery. It also highlights the incredible support they received from their community and the medical team that performed the surgery.",
    amount: '13200',
    createdAt: '2020-11-11',
    expiredAt: ' 2024-01-09'
  },
  {
    category: 'Others',
    images: '',
    title: "The Impact of Community Support on Children's Health Outcomes",
    content:
      'A research-based article that explores the positive effects of community support on the health outcomes of children in need of surgery. The article includes data from several studies that have shown the benefits of social support in improving recovery times and overall well-being. It also features case studies of children who have benefited from community-funded surgeries and the long-term impacts on their lives.',
    amount: '11700',
    createdAt: '2022-03-13',
    expiredAt: ' 2024-04-07'
  },
  {
    category: 'Others',
    images: '',
    title: 'Bridging the Gap: The Role of Nonprofits in Pediatric Healthcare',
    content:
      'This article provides a comprehensive overview of how nonprofit organizations are filling the gap in pediatric healthcare services for children in poverty. It includes case studies of successful programs that have provided necessary surgeries for children in need and discusses the challenges these organizations face in securing funding and resources. The article also includes interviews with healthcare professionals and nonprofit leaders who share their insights on the importance of these programs.',
    amount: '6800',
    createdAt: '2022-08-20',
    expiredAt: ' 2024-03-15'
  },
  {
    category: 'Others',
    images: '',
    title: 'Saving Lives, One Donation at a Time: The Power of Giving to Pediatric Surgery Funds',
    content:
      'A motivational piece that encourages readers to donate to funds that support pediatric surgeries. The article includes stories of children who have benefited from these funds and the life-changing impact of the surgeries. It also discusses the different ways people can donate, from monetary contributions to volunteering time and resources. The article aims to inspire readers to take action and make a difference in the lives of children in need.',
    amount: '14300',
    createdAt: '2020-07-10',
    expiredAt: ' 2024-07-24'
  },
  {
    category: 'Others',
    images: '',
    title: 'In Their Time of Need: How You Can Help Children Facing Medical Crises',
    content:
      'A practical guide on how individuals can support children and families facing medical crises. The article provides information on the various ways people can help, from donating to surgery funds and volunteering at hospitals to providing emotional support for families. It also includes resources for those who want to learn more about pediatric medical crises and how they can get involved in advocacy efforts.',
    amount: '5200',
    createdAt: '2023-02-03',
    expiredAt: ' 2024-03-27'
  },
  {
    category: 'Others',
    images: '',
    title: 'The Struggle for Pediatric Surgery: A Glimpse into the Lives of Those in Need',
    content:
      "Maria lived in a small, impoverished village where medical facilities were scarce and the closest hospital was miles away. Her young son, James, fell seriously ill and required urgent surgery. The cost of the surgery was beyond their means, and with a heavy heart, Maria reached out to her community for support. The villagers, though not well-off themselves, contributed what they could. Local churches and non-profits also stepped in, and with the help of generous donors from around the world, Maria was able to get James the life-saving surgery he needed. This story highlights the importance of community, empathy, and the impact that even a small donation can have on a child's life.",
    amount: '10300',
    createdAt: '2022-01-26',
    expiredAt: ' 2024-07-01'
  },
  {
    category: 'Others',
    images: '',
    title: 'A Second Chance at Life: The Heartwarming Story of Baby John ',
    content:
      "Baby John was born with a congenital heart defect, a condition that required immediate surgery. His family, living in a low-income neighborhood, had no means to afford the exorbitant medical costs. The clock was ticking, and Baby John's life was on the line. In an act of desperation, his family reached out to various non-profit organizations and set up a crowdfunding campaign. The response was overwhelming. Donations poured in from all corners of the globe, and Baby John was able to undergo the surgery. Today, he is a thriving toddler, full of life and energy. This story is a testament to the power of human kindness and the difference that we can make when we come together for a common cause.",
    amount: '4200',
    createdAt: '2021-02-22',
    expiredAt: ' 2024-02-27'
  },
  {
    category: 'Pets',
    images: '',
    title: "Fighting for a Brighter Future: Emily's Brave Battle Against Cancer ",
    content:
      "At just eight years old, Emily was diagnosed with a rare form of cancer. The news was a devastating blow to her family, who were already struggling to make ends meet. The cost of the treatment was astronomical, but Emily's parents were determined to do whatever it took to save their daughter's life. They reached out to family, friends, and even strangers, sharing Emily's story and asking for financial support. The community rallied around them, and along with the help of charitable organizations and kind-hearted donors, Emily was able to receive the treatment she desperately needed. Today, she is cancer-free and has become a symbol of hope and resilience for many others facing similar challenges.",
    amount: '3100',
    createdAt: '2021-06-20',
    expiredAt: ' 2024-05-01'
  },
  {
    category: 'Pets',
    images: '',
    title: "A Helping Hand: The Community's Role in Supporting Pediatric Care ",
    content:
      "Alex was a bright and energetic teenager who loved playing soccer. One day, while playing a match, he suffered a serious injury that required immediate surgery. His family, already burdened with financial difficulties, was crushed by the news. The medical bills were more than they could handle. But their community was not ready to let them fight this battle alone. Local businesses, neighbors, and even strangers came together to raise funds for Alex's surgery. They organized bake sales, car washes, and other fundraising events. The outpouring of support was incredible, and Alex was able to undergo the surgery. Today, he is back on the soccer field, living his dream, thanks to the generosity and kindness of those around him.",
    amount: '1600',
    createdAt: '2020-09-18',
    expiredAt: ' 2024-02-08'
  },
  {
    category: 'Pets',
    images: '',
    title: "A Mother's Fight for Her Child: Emma's Incredible Journey to Recovery ",
    content:
      "Emma was just two years old when she was diagnosed with a rare and life-threatening illness. Her mother, a single parent working two jobs, was devastated by the news. The cost of the surgery and subsequent treatment was more than she could bear. In a desperate plea for help, she reached out to the public, sharing her daughter's story and asking for financial support. The response was heartwarming. People from all walks of life came forward to donate, and within weeks, the necessary funds were raised. Emma underwent the surgery and made a miraculous recovery. This story is a testament to the goodness that exists in the world and the incredible impact that one person's generosity can have on another's life.",
    amount: '2300',
    createdAt: '2023-10-14',
    expiredAt: ' 2024-01-03'
  },
  {
    category: 'Pets',
    images: '',
    title: 'The Struggle for Pediatric Surgery: A Tale of Financial Hardship',
    content:
      "A detailed story about Emily, a seven-year-old girl who was diagnosed with a congenital heart defect. The family's insurance did not cover the full cost of the surgery, and they were faced with the overwhelming burden of medical bills. The local community came together to organize fundraisers, including a charity walk and a silent auction, to help Emily's family cover the costs. The article dives into the emotional toll this situation took on Emily's family and the community's incredible display of support.",
    amount: '1700',
    createdAt: '2021-03-20',
    expiredAt: ' 2024-05-15'
  },
  {
    category: 'Pets',
    images: '',
    title: 'A Call for Help: Providing Life-Saving Surgery for Children in Need',
    content:
      'This comprehensive article provides an in-depth look at several charity organizations that specialize in funding surgeries for children whose families cannot afford the medical costs. It explores the process of how these charities work, the criteria for eligibility, and the stories of children who have benefited from these programs. The article also includes interviews with medical professionals and charity founders who share their experiences and the impact of these organizations.',
    amount: '5500',
    createdAt: '2022-09-08',
    expiredAt: ' 2024-06-20'
  },
  {
    category: 'Pets',
    images: '',
    title: "The Hidden Costs of Childhood Illness: A Family's Journey",
    content:
      'A narrative that follows the Johnson family as they navigate the complex world of medical bills and insurance claims after their son, Michael, was hospitalized for pneumonia and needed surgery. The story sheds light on the often-overlooked costs associated with hospital stays, such as transportation, lost wages, and out-of-pocket expenses for medical equipment. The article also discusses the emotional and mental health impacts on the family and how they found support through a local non-profit organization.',
    amount: '12800',
    createdAt: '2023-05-05',
    expiredAt: ' 2024-03-20'
  },
  {
    category: 'Pets',
    images: '',
    title: 'Breaking the Cycle: How Your Donations Can Help Children Access Medical Care',
    content:
      'This piece delves into the various ways in which donations can make a significant difference in the lives of children in need of medical care. It highlights the story of a young girl named Lily who was able to receive a life-changing surgery thanks to a scholarship fund set up by a local charity. The article also discusses the importance of transparency in charity organizations and how donors can ensure their contributions are being used effectively.',
    amount: '17800',
    createdAt: '2022-11-08',
    expiredAt: ' 2024-07-18'
  },
  {
    category: 'Pets',
    images: '',
    title: 'Fighting for Their Lives: The Critical Need for Pediatric Surgical Funding',
    content:
      'An in-depth analysis of the current state of pediatric surgical funding, with a focus on the disparities in access to medical care for children in low-income families. The article features interviews with healthcare policy experts, surgeons, and families who have experienced these disparities firsthand. It also discusses potential solutions, such as government-funded programs and increased support for charity organizations.',
    amount: '7400',
    createdAt: '2021-10-07',
    expiredAt: ' 2024-01-05'
  },
  {
    category: 'Pets',
    images: '',
    title: "From Desperation to Hope: A Young Boy's Surgery Success Story",
    content:
      "A heartfelt story about a young boy named Charlie who was born with a life-threatening condition that required immediate surgery. The article chronicles Charlie's journey from diagnosis to recovery, with a focus on the challenges his family faced in securing the necessary funds for the surgery. It also highlights the incredible support they received from their community and the medical team that performed the surgery.",
    amount: '6200',
    createdAt: '2023-04-03',
    expiredAt: ' 2024-04-10'
  },
  {
    category: 'Pets',
    images: '',
    title: "The Impact of Community Support on Children's Health Outcomes",
    content:
      'A research-based article that explores the positive effects of community support on the health outcomes of children in need of surgery. The article includes data from several studies that have shown the benefits of social support in improving recovery times and overall well-being. It also features case studies of children who have benefited from community-funded surgeries and the long-term impacts on their lives.',
    amount: '9200',
    createdAt: '2021-12-18',
    expiredAt: ' 2024-06-06'
  },
  {
    category: 'Pets',
    images: '',
    title: 'Bridging the Gap: The Role of Nonprofits in Pediatric Healthcare',
    content:
      'This article provides a comprehensive overview of how nonprofit organizations are filling the gap in pediatric healthcare services for children in poverty. It includes case studies of successful programs that have provided necessary surgeries for children in need and discusses the challenges these organizations face in securing funding and resources. The article also includes interviews with healthcare professionals and nonprofit leaders who share their insights on the importance of these programs.',
    amount: '14700',
    createdAt: '2022-05-24',
    expiredAt: ' 2023-12-20'
  },
  {
    category: 'Pets',
    images: '',
    title: 'Saving Lives, One Donation at a Time: The Power of Giving to Pediatric Surgery Funds',
    content:
      'A motivational piece that encourages readers to donate to funds that support pediatric surgeries. The article includes stories of children who have benefited from these funds and the life-changing impact of the surgeries. It also discusses the different ways people can donate, from monetary contributions to volunteering time and resources. The article aims to inspire readers to take action and make a difference in the lives of children in need.',
    amount: '5900',
    createdAt: '2020-03-14',
    expiredAt: ' 2024-05-10'
  },
  {
    category: 'Pets',
    images: '',
    title: 'In Their Time of Need: How You Can Help Children Facing Medical Crises',
    content:
      'A practical guide on how individuals can support children and families facing medical crises. The article provides information on the various ways people can help, from donating to surgery funds and volunteering at hospitals to providing emotional support for families. It also includes resources for those who want to learn more about pediatric medical crises and how they can get involved in advocacy efforts.',
    amount: '3400',
    createdAt: '2023-09-17',
    expiredAt: ' 2024-02-02'
  },
  {
    category: 'Pets',
    images: '',
    title: 'The Struggle for Pediatric Surgery: A Glimpse into the Lives of Those in Need',
    content:
      "Maria lived in a small, impoverished village where medical facilities were scarce and the closest hospital was miles away. Her young son, James, fell seriously ill and required urgent surgery. The cost of the surgery was beyond their means, and with a heavy heart, Maria reached out to her community for support. The villagers, though not well-off themselves, contributed what they could. Local churches and non-profits also stepped in, and with the help of generous donors from around the world, Maria was able to get James the life-saving surgery he needed. This story highlights the importance of community, empathy, and the impact that even a small donation can have on a child's life.",
    amount: '8800',
    createdAt: '2023-06-06',
    expiredAt: ' 2024-06-28'
  },
  {
    category: 'Pets',
    images: '',
    title: 'A Second Chance at Life: The Heartwarming Story of Baby John ',
    content:
      "Baby John was born with a congenital heart defect, a condition that required immediate surgery. His family, living in a low-income neighborhood, had no means to afford the exorbitant medical costs. The clock was ticking, and Baby John's life was on the line. In an act of desperation, his family reached out to various non-profit organizations and set up a crowdfunding campaign. The response was overwhelming. Donations poured in from all corners of the globe, and Baby John was able to undergo the surgery. Today, he is a thriving toddler, full of life and energy. This story is a testament to the power of human kindness and the difference that we can make when we come together for a common cause.",
    amount: '11200',
    createdAt: '2021-07-28',
    expiredAt: ' 2024-07-30'
  },
  {
    category: 'Pets',
    images: '',
    title: "Fighting for a Brighter Future: Emily's Brave Battle Against Cancer ",
    content:
      "At just eight years old, Emily was diagnosed with a rare form of cancer. The news was a devastating blow to her family, who were already struggling to make ends meet. The cost of the treatment was astronomical, but Emily's parents were determined to do whatever it took to save their daughter's life. They reached out to family, friends, and even strangers, sharing Emily's story and asking for financial support. The community rallied around them, and along with the help of charitable organizations and kind-hearted donors, Emily was able to receive the treatment she desperately needed. Today, she is cancer-free and has become a symbol of hope and resilience for many others facing similar challenges.",
    amount: '2900',
    createdAt: '2020-01-17',
    expiredAt: ' 2024-01-17'
  },
  {
    category: 'Pets',
    images: '',
    title: "A Helping Hand: The Community's Role in Supporting Pediatric Care ",
    content:
      "Alex was a bright and energetic teenager who loved playing soccer. One day, while playing a match, he suffered a serious injury that required immediate surgery. His family, already burdened with financial difficulties, was crushed by the news. The medical bills were more than they could handle. But their community was not ready to let them fight this battle alone. Local businesses, neighbors, and even strangers came together to raise funds for Alex's surgery. They organized bake sales, car washes, and other fundraising events. The outpouring of support was incredible, and Alex was able to undergo the surgery. Today, he is back on the soccer field, living his dream, thanks to the generosity and kindness of those around him.",
    amount: '4300',
    createdAt: '2022-02-06',
    expiredAt: ' 2024-03-12'
  },
  {
    category: 'Pets',
    images: '',
    title: "A Mother's Fight for Her Child: Emma's Incredible Journey to Recovery ",
    content:
      "Emma was just two years old when she was diagnosed with a rare and life-threatening illness. Her mother, a single parent working two jobs, was devastated by the news. The cost of the surgery and subsequent treatment was more than she could bear. In a desperate plea for help, she reached out to the public, sharing her daughter's story and asking for financial support. The response was heartwarming. People from all walks of life came forward to donate, and within weeks, the necessary funds were raised. Emma underwent the surgery and made a miraculous recovery. This story is a testament to the goodness that exists in the world and the incredible impact that one person's generosity can have on another's life.",
    amount: '1400',
    createdAt: '2020-08-09',
    expiredAt: ' 2024-04-03'
  },
  {
    category: 'Pets',
    images: '',
    title: 'The Struggle for Pediatric Surgery: A Tale of Financial Hardship',
    content:
      "A detailed story about Emily, a seven-year-old girl who was diagnosed with a congenital heart defect. The family's insurance did not cover the full cost of the surgery, and they were faced with the overwhelming burden of medical bills. The local community came together to organize fundraisers, including a charity walk and a silent auction, to help Emily's family cover the costs. The article dives into the emotional toll this situation took on Emily's family and the community's incredible display of support.",
    amount: '2700',
    createdAt: '2020-04-26',
    expiredAt: ' 2024-07-08'
  },
  {
    category: 'Pets',
    images: '',
    title: 'A Call for Help: Providing Life-Saving Surgery for Children in Need',
    content:
      'This comprehensive article provides an in-depth look at several charity organizations that specialize in funding surgeries for children whose families cannot afford the medical costs. It explores the process of how these charities work, the criteria for eligibility, and the stories of children who have benefited from these programs. The article also includes interviews with medical professionals and charity founders who share their experiences and the impact of these organizations.',
    amount: '6600',
    createdAt: '2021-01-07',
    expiredAt: ' 2024-05-17'
  },
  {
    category: 'Pets',
    images: '',
    title: "The Hidden Costs of Childhood Illness: A Family's Journey",
    content:
      'A narrative that follows the Johnson family as they navigate the complex world of medical bills and insurance claims after their son, Michael, was hospitalized for pneumonia and needed surgery. The story sheds light on the often-overlooked costs associated with hospital stays, such as transportation, lost wages, and out-of-pocket expenses for medical equipment. The article also discusses the emotional and mental health impacts on the family and how they found support through a local non-profit organization.',
    amount: '3900',
    createdAt: '2023-08-06',
    expiredAt: ' 2024-02-24'
  },
  {
    category: 'Pets',
    images: '',
    title: 'Breaking the Cycle: How Your Donations Can Help Children Access Medical Care',
    content:
      'This piece delves into the various ways in which donations can make a significant difference in the lives of children in need of medical care. It highlights the story of a young girl named Lily who was able to receive a life-changing surgery thanks to a scholarship fund set up by a local charity. The article also discusses the importance of transparency in charity organizations and how donors can ensure their contributions are being used effectively.',
    amount: '2400',
    createdAt: '2022-07-21',
    expiredAt: ' 2024-03-05'
  },
  {
    category: 'Pets',
    images: '',
    title: 'Fighting for Their Lives: The Critical Need for Pediatric Surgical Funding',
    content:
      'An in-depth analysis of the current state of pediatric surgical funding, with a focus on the disparities in access to medical care for children in low-income families. The article features interviews with healthcare policy experts, surgeons, and families who have experienced these disparities firsthand. It also discusses potential solutions, such as government-funded programs and increased support for charity organizations.',
    amount: '1900',
    createdAt: '2020-11-04',
    expiredAt: ' 2024-06-24'
  }
]
